import { PropsWithChildren, useEffect, useRef } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

import { env } from '@percent/admin-dashboard/env'
import { useAuthState } from '@percent/admin-dashboard/common/hooks/useAuthState/useAuthState'
import { getPostHogApiHost } from '@percent/utility'

export function PostHogProvider({ children }: PropsWithChildren) {
  const apiKey = env.NX_PUBLIC_POSTHOG_API_KEY
  const initialized = useRef(false)

  const { user } = useAuthState()

  useEffect(() => {
    if (!apiKey) return

    if (!initialized.current) {
      posthog.init(apiKey, {
        api_host: getPostHogApiHost(window.location.hostname),
        ui_host: 'https://eu.posthog.com',
        capture_pageview: false,
        capture_pageleave: false,
        autocapture: false,
        disable_session_recording: true,
        person_profiles: 'identified_only'
      })
      posthog.register({ app: 'admin-dashboard' })
      initialized.current = true
    }

    if (user?.id) {
      posthog.identify(user.id, { email: user.email })
      posthog.reloadFeatureFlags()
    } else {
      posthog.reset()
    }
  }, [apiKey, user?.id, user?.email])

  if (!apiKey) return children

  return <PHProvider client={posthog}>{children}</PHProvider>
}
